var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "9 -69 92 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4902-16.0645L36.8652-16.0645C39.1113-16.0645 40.625-17.5781 40.625-19.7266L40.625-26.8066C40.625-28.9551 39.1113-30.4688 36.8652-30.4688L27.4902-30.4688C25.2441-30.4688 23.7305-28.9551 23.7305-26.8066L23.7305-19.7266C23.7305-17.5781 25.2441-16.0645 27.4902-16.0645ZM13.2812-43.6035L96.8262-43.6035L96.8262-52.3926L13.2812-52.3926ZM22.2168-2.09961L87.8418-2.09961C96.1914-2.09961 100.293-6.15234 100.293-14.3555L100.293-56.0547C100.293-64.2578 96.1914-68.3105 87.8418-68.3105L22.2168-68.3105C13.916-68.3105 9.76562-64.2578 9.76562-56.0547L9.76562-14.3555C9.76562-6.15234 13.916-2.09961 22.2168-2.09961ZM22.3145-9.13086C18.7988-9.13086 16.7969-11.0352 16.7969-14.7461L16.7969-55.6641C16.7969-59.375 18.7988-61.2793 22.3145-61.2793L87.7441-61.2793C91.2598-61.2793 93.2617-59.375 93.2617-55.6641L93.2617-14.7461C93.2617-11.0352 91.2598-9.13086 87.7441-9.13086Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.b3cdb5f132a5018036755485ce297628.svg";
export { ForwardRef as ReactComponent };